export default class UtilityCountry {

    constructor(jsonResponse) {

        this.alpha2 = jsonResponse["alpha2"];
        this.alpha3 = jsonResponse["alpha3"];
        this.name = jsonResponse["name"] + " (" + this.alpha3 + ")";
        this.nameOriginal = jsonResponse["name"];

    this.iconClass = this.alpha2.toLowerCase();

        this.id = this.alpha3;
    }
}
